import { RestaurantCheckout } from '@happyspace/sdk/restaurant';
import { useNavigate } from 'react-router-dom';

export default function CartDrawer({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) {
  const navigate = useNavigate();

  return (
    <RestaurantCheckout
      isOpen={isOpen}
      onClose={onClose}
      accentColor="#B3241D"
      restaurantName="Biryani2Go"
      onOrderSuccess={(order) => {
        navigate('/order-confirmation', { state: { order } });
      }}
    />
  );
}
